import { Theme, ThemeUICSSObject } from 'theme-ui';
import { getSelectedColors } from '../colors/index';
/* IMPORT HERE */

function selectMultiple(theme: Theme): ThemeUICSSObject {
  return {
    variant: 'text.default',
    height: '100%',
    padding: '4px',
    borderRadius: 'default',
    border: '1px solid',
    width: '100%',
    transition: 'background-color 100ms ease-out, color 100ms ease-out',
    overflow: 'auto',
    option: {
      padding: 2,
      ...getSelectedColors(theme.palette),

      '&:checked': {
        backgroundColor: theme.palette.getColor(
          theme.palette.background.paper,
          'selected',
        ),
        color: theme.palette.getContrastText(
          theme.palette.getColor(theme.palette.background.paper, 'selected'),
        ),
      },
    },
    '+ svg': {
      display: 'none',
    },
    ...theme.palette.getStatesFromPath('form.fields', {
      states: {
        active: false,
        hover: false,
        focus: false,
      },
    }),
  };
}

export default selectMultiple;
